import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryCards() {
  const { t } = useTranslation();

  const iconColors = [
    'bg-primary-100 text-primary-600',
    'bg-accent-100 text-accent-700',
    'bg-secondary-100 text-secondary-700',
    'bg-primary-100 text-primary-600',
    'bg-accent-100 text-accent-700',
  ];

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            {t('home.categories.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {t('home.categories.subtitle')}
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat, index) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg p-5 md:p-6 text-center transition-all duration-300 hover:scale-[1.02] cursor-pointer border border-background-200/60"
            >
              <div
                className={`w-14 h-14 md:w-16 md:h-16 mx-auto mb-3 rounded-lg flex items-center justify-center ${iconColors[index]} transition-colors group-hover:bg-primary-500 group-hover:text-background-50`}
              >
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 font-heading">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500">
                {cat.articleCount} 篇文章
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}